import React, { useEffect, useState } from 'react';
import './Safaris.css';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { SlLocationPin } from "react-icons/sl";
import { FaRegCalendarAlt } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";

function Safaris() {
  const [tours, setTours] = useState([]);
  const navigate = useNavigate();
  // Correctly destructure useSearchParams
  const [, setSearchParams] = useSearchParams();

  useEffect(() => {

    AOS.init();
    AOS.refresh();

    async function fetchTours() {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/tours`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setTours(data);
      } catch (error) {
        console.error('Error fetching tours:', error);
      }
    }

    fetchTours();
  }, [navigate]);

  const handleCardClick = (tour) => {
    setSearchParams({ id: tour.id });
    navigate(`/tour-packages?id=${tour.id}`);
  };

  return (
    <div data-aos="zoom-in" className="safari_container">
      <div className="safari_title">
        <p className='title-primary'>Popular Destinations</p>
        <p className='title-secondary'>Explore The World For Yourself</p>
      </div>

      <div className="safari_box">
        <div className="card-container">
        {tours.slice(0, 12).map(tour => (
            <div key={tour.id} className="card" onClick={() => handleCardClick(tour)}>
              <div className="card__image_container">
                <img src={`${process.env.REACT_APP_BASE_URL}/${tour.image_preview}`} alt={tour.destination_name} className="card__image" />
              </div>
              <div className="card__info">
                <div className="card-row">
                  <p className="card__text">${tour.price}<span className='per'>/Per Person</span></p>
                  <p className="card__detail days">
                    <FaRegCalendarAlt className='icon__tour' />
                    {tour.duration} Days/ {tour.duration - 1} Nights
                  </p>
                </div>

                <div className="card__title" style={{lineHeight:"25px"}}>                  
                  <span style={{fontSize:'17px', color:"#A27B5C" , fontWeight:'bold'}}>{tour.destination_title}</span> <br />
                  <span style={{fontSize:'15px', fontWeight:'bold'}}><SlLocationPin className='icon__tour' />{tour.destination_name}</span>                   
                </div>

                {/* <div className="card__details">
                  <p><span className="star">★</span> 8K+ rating</p> 
                </div> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Safaris;
